import { taskItem } from './taskItem';
const nestedNode = (node, depth = 1) => {
  const result = [];
  node.forEach(item => {
    if (item.type.name === 'taskList') {
      result.push(nestedNode(item, depth + 1));
    } else {
      result.push(taskItem(item, depth));
    }
  });
  return result.join('\n');
};
export const taskList = node => {
  return nestedNode(node);
};